import Accordian from "./Accordian";
import Ping from "./Ping";

export default function SidebarLink({
  item,
  showPing,
}: {
  item: any;
  showPing: boolean;
}) {
  return item.href !== null ? (
    <a
      href={item.href}
      className="group text-light hover:text-white hover:bg-light/10 flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold pr-16"
    >
      <item.icon
        className="h-6 w-6 my-auto shrink-0 group-hover:text-info inline"
        aria-hidden="true"
      />
      {item.name}
      {showPing && (
        <Ping colour="danger" position="right-5" size={4} className="mt-1" />
      )}
    </a>
  ) : (
    <Accordian item={item} />
  );
}
